import { Component, Input, OnInit } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { EffectivenessModel, EvidenceSampleEditModel } from "../../../shared/models";
import { EffExpansionPanelComponent } from "../../common/eff-expansion-panel/eff-expansion-panel.component";

@Component({
    selector: "eff-test-instructions-info-box",
    templateUrl: "./eff-test-instructions-info-box.component.html",
    styleUrls: ["./eff-test-instructions-info-box.component.scss"],
    imports: [TranslocoPipe, EffExpansionPanelComponent]
})
export class EffTestInstructionsInfoBoxComponent implements OnInit {
    @Input() effectivenessGuid: string;
    @Input() samples: EvidenceSampleEditModel[];
    @Input() effectivenessModel: EffectivenessModel;
    @Input() showEvidenceUploadInstructions: boolean = false;
    @Input() panelOpenState: boolean = false;

    constructor() {}

    ngOnInit(): void {}
}
